import { Button } from '../ui/Button'

interface ConsentButtonsProps {
  onAllow: () => void
  onDeny: () => void
  loading?: boolean
  allowText?: string
  denyText?: string
}

export function ConsentButtons({
  onAllow,
  onDeny,
  loading = false,
  allowText = 'Allow',
  denyText = 'Deny',
}: ConsentButtonsProps) {
  return (
    <div className="flex gap-3">
      <Button
        variant="outline"
        onClick={onDeny}
        disabled={loading}
        className="flex-1"
      >
        {denyText}
      </Button>
      <Button
        variant="primary"
        onClick={onAllow}
        loading={loading}
        className="flex-1"
      >
        {allowText}
      </Button>
    </div>
  )
}
